import { Header, Trigger } from '@radix-ui/react-accordion';
import styled, { css } from 'styled-components';

import { BUTTON_BASE_RESET_CSS } from '@pkg/components/Sections/Profile/Buttons';

import { FILTER_CONTENT_PADDING, FILTER_HEADING_PADDING } from '../constants';

const StyledAccordionButton = styled(Trigger)`
    && {
        ${BUTTON_BASE_RESET_CSS}
    }
`;

export const StyledFilterHeadingContainer = styled.div<{ $noPadding?: boolean }>`
    && {
        align-items: center;
        display: flex;
        //justify-content: space-between;
        margin: 0;
        min-width: 100%;
        padding: ${FILTER_CONTENT_PADDING}px 0 0 0;
        width: 100%;
        box-sizing: border-box;
        ${({ $noPadding }) =>
            $noPadding &&
            css`
                padding: 0;
            `};
    }
`;

export const StyledFilterHeadingTitleContainer = styled.span`
    && {
        display: inline-flex;
        gap: 10px;
        align-items: center;
        overflow: hidden;
        flex: 1;
    }
`;

export const StyledFilterHeadingTitle = styled(Header)<{
    $noPadding?: boolean;
    $disableUpperCase?: boolean;
}>`
    && {
        box-sizing: border-box;
        color: ${({ theme }) => theme.colors.white};
        display: inline-flex;
        gap: 5px;
        font-family: 'Alliance No.1', serif;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 700;
        justify-content: space-between;
        letter-spacing: 0.02em;
        line-height: 1;
        margin: 0;
        width: 100%;
        overflow: hidden;
        padding: ${FILTER_HEADING_PADDING}px 0;
        ${({ $noPadding }) =>
            $noPadding &&
            css`
                padding: 0;
            `};
        text-align: left;
        text-overflow: ellipsis;
        text-transform: ${({ $disableUpperCase }) => ($disableUpperCase ? 'unset' : 'uppercase')};
        white-space: nowrap;
    }
`;

export const DisplayToggle = styled(StyledAccordionButton)`
    display: flex;
    justify-content: center;
    align-items: center;
    && {
        background: ${(props) => props.theme.shades.white['10']};
        border-radius: 50px;
        border: none;
        color: ${(props) => props.theme.shades.white['50']};
        cursor: pointer;
        flex: 0 0 auto;
        height: 20px;
        margin-left: 10px;
        position: relative;
        width: 20px;

        &:hover {
            background: ${(props) => props.theme.shades.white['20']};
        }

        > span {
            font-size: 20px;
            font-weight: bold;
            background: ${({ theme }) => theme.colors.white};
            display: block;
            height: 1px;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate(-50%);
            width: 10px;
        }

        span:not(:first-child) {
            transform: translate(-50%) rotate(90deg);
        }

        :disabled {
            display: none;
        }
    }
`;
